<template>
  <el-form
    :model="selectTeamForm"
    :rules="getFormRules"
    ref="selectTeamForm"
    label-position="top"
    v-loading.fullscreen.lock="fullScreenLoading"
  >
    <el-form-item
      :label="$t('re-conciliation.choose-team.team')"
      prop="team"
    >
      <el-select
        v-model="selectTeamForm.team"
        @change="setPoolingStrategy"
      >
        <el-option
          v-for="(team, index) in teams"
          :key="index"
          :label="team.name"
          :value="team.id"
        >
          <span class="select-item truncate">{{ team.name }}</span>
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-row class="mt-20 mb-20">
        <el-col :span="11">
          <el-button
            type="cancel"
            class="cancel-button"
            @click="resetForm"
          >
            {{ $t('form.reset') }}
          </el-button>
        </el-col>
        <el-col
          :offset="2"
          :span="11"
        >
          <el-button
            type="primary"
            class="primary-button"
            @click="submitForm('selectTeamForm')"
          >
            {{ $t('form.next') }}
          </el-button>
        </el-col>
      </el-row>
    </el-form-item>
  </el-form>
</template>

<script>
import authHelpers from '@/plugins/auth-helpers';

export default {
  name: 'SelectTeam',
  data: () => ({
    fullScreenLoading: true,
    selectTeamForm: {
      team: '',
      strategy: 'complex'
    },
    teams: []
  }),
  created () {
    authHelpers.isCurrentUserTeamResp().then((isTeamResp) => {
      if (isTeamResp) {
        this.getCurrentUser().then((user) => {
          this.getTeams(user.attributes.sub).then(() => {
            this.fullScreenLoading = false;
          })
            .catch(() => {
              this.fullScreenLoading = false;
            });
        })
          .catch(() => {
            this.fullScreenLoading = false;
          });
      }
    });
  },
  computed: {
    getFormRules: function () {
      return {
        team: [
          {
            required: true,
            message: this.$t('form.validation.required', { field: this.$t('re-conciliation.choose-team.team') }),
            trigger: 'change'
          }
        ],
        strategy: [
          {
            required: true,
            message: this.$t('form.validation.required', { field: this.$t('re-conciliation.choose-team.strategy') }),
            trigger: 'change'
          }
        ]
      };
    }
  },
  methods: {
    submitForm (formName = '') {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$router.push({
            name: 'SetDate',
            params: { teamId: this.selectTeamForm.team }
          });

        } else {
          return false;
        }
      });
    },
    getTeams (userId = '') {
      return this.$adminApi.get(`/api/v1/entities/teams/representatives/${userId}`).then((teams) => {
        this.teams = teams.data.filter((team) => team.sharingType === 'Pooling');
      });
    },
    resetForm () {
      this.$refs['selectTeamForm'].resetFields();
    },
    setPoolingStrategy (teamId = '') {
      const team = this.teams.find((team) => {
        return team.id === teamId;
      });
      if (team.poolingStrategy) {
        this.selectTeamForm.strategy = team.poolingStrategy;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.select-item {
  width: 320px;
  white-space: normal;
  overflow: hidden;
}
</style>
